import { users } from '../../../lib/apiList'
import axios from '../../../lib/axios'

interface GetUserParams {
    currentPage?: number | null
    recordsPerPage?: number | null
    advancedSearch?: {
        keyword: string | null
    }
    isglobalSearch?: boolean
    isActiveFilter?: boolean
}

interface TogglePayload {
    activateUser: boolean
    userId: string
}

interface ChangePasswordPayload {
    userId: string
    newPassword: string
    confirmPassword?: string
}

export const getAllAdminUsers = ({
    currentPage,
    recordsPerPage,
    advancedSearch,
    isglobalSearch,
    isActiveFilter,
}: GetUserParams): Promise<any> => {
    const data = {
        pageSize: recordsPerPage ? recordsPerPage : 5,
        pageNumber: currentPage ? currentPage : 1,
        advancedSearch: advancedSearch,
        isglobalSearch: isglobalSearch,
        isActiveFilter: isActiveFilter,
    }
    return axios.post(users.GETALLUSERS, data)
}

export const toggleUserStatus = (
    data: TogglePayload,
    id: string
): Promise<any> => {
    return axios.post(`${users.TOGGLEUSER}/${id}/toggle-status`, data)
}

export const resendEmail = (userId: string): Promise<any> => {
    return axios.post(users.RESENDEMAIL, { userId })
}

export const changePasswordByAdmin = (
    body: ChangePasswordPayload
): Promise<any> => {
    return axios.post(users.CHANGEPASSWORD, body)
}

export const deleteUser = (data: { userId: string }): Promise<any> => {
    const url = `${users.DELETEUSER}`
    return axios.delete(url, {
        data: data,
    })
}
